const Error = () => {
    return document.body.innerHTML = "<h1>Error 404</h1><h2>Not Found</h2>";
};

export default Error;